import Model from '../Model'
import {isNull} from "lodash";

export default class ResourcePlanningReport extends Model {
    static async find(packageReference) {
        const data = await Http.get(route('api.v2.project-delivery.resource-planning-report', {package_reference: packageReference}), {})
        if (data.packageReference) {
            return this.make(data)
        }
        return null
    }

    async reload() {
        let contract = await ResourcePlanningReport.find(this.id)
        Object.assign(this, contract)
    }

    static async reset(packageReference) {
        const url = route('api.v2.project-delivery.resource-planning-report.reset', {package_reference: packageReference})
        const o = await Http.post(url, {})
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.buildTokens()
    }

    buildTokens() {
        let tokens = [
            this.date,
            this.id,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

}
